window._ = require("lodash");

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

try {
    window.Popper = require("popper.js").default;
    // window.$ = require("jquery");
    // window.jQuery = require("jquery");
    // $ = require("jquery");
    // jQuery = require("jquery");
    // window.Swal = require("sweetalert2");
    // window.toastr = require("toastr");

    // require("admin-lte");
    // require("@fortawesome/fontawesome-free/js/all");

    require("bootstrap");
} catch (e) {}
